import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=0d366453&scoped=true"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"
import style0 from "./calendar.vue?vue&type=style&index=0&id=0d366453&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d366453",
  null
  
)

export default component.exports